import { render, staticRenderFns } from "./BtnExcluirCronogramaDesembolsoSebrae.vue?vue&type=template&id=ab3ab8c8"
import script from "./BtnExcluirCronogramaDesembolsoSebrae.vue?vue&type=script&lang=js"
export * from "./BtnExcluirCronogramaDesembolsoSebrae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports